// ============================================================================
// OBT F3-E — Kullanıcı bildirim yüzeyi API (paket-yerel)
// ============================================================================
// Paylaşılan `notification` inbox'ı üzerinde OBT-kapsamlı okuma. Aktör HİÇBİR
// çağrıda body/query ile GÖNDERİLMEZ; backend JWT'den çözer, yalnız kendi
// bildirimleri döner (enumeration engeli: başkasının id'si 404).
// ============================================================================

import apiClient from '@/api/client';

const OBT = '/obt';
const enc = encodeURIComponent;

export async function fetchObtNotifications(
  { unreadOnly, eventType, limit, offset } = {},
  { signal } = {}
) {
  const params = {};
  if (unreadOnly) params.unread_only = true;
  if (eventType) params.event_type = eventType;
  if (typeof limit === 'number') params.limit = limit;
  if (typeof offset === 'number') params.offset = offset;
  const res = await apiClient.get(`${OBT}/notifications`, { params, signal });
  return res.data; // { page, unread_count, items }
}

export async function fetchObtUnreadCount({ signal } = {}) {
  const res = await apiClient.get(`${OBT}/notifications/unread-count`, { signal });
  return res.data?.unread_count ?? 0;
}

export async function markObtNotificationRead(notificationId, { signal } = {}) {
  const res = await apiClient.post(
    `${OBT}/notifications/${enc(notificationId)}/read`,
    {},
    { signal }
  );
  return res.data;
}

export async function markAllObtNotificationsRead({ signal } = {}) {
  const res = await apiClient.post(`${OBT}/notifications/read-all`, {}, { signal });
  return res.data;
}
